import { FormattingRule } from './types';
import { getNextColorForFormattingRule } from './getFormattingNextColor';

export const addNewFormattingRule = (
  previousRules: FormattingRule[],
  newRule: FormattingRule,
  isNewConditionalFormatting: boolean = false,
  viewId?: string
) => {
  // Assign next available color for the new rule if the feature is enabled
  const newRuleWithColor = isNewConditionalFormatting
    ? {
        ...newRule,
        color:
          getNextColorForFormattingRule(previousRules, viewId) || newRule.color,
      }
    : newRule;

  return isNewConditionalFormatting
    ? [newRuleWithColor, ...previousRules]
    : [...previousRules, newRuleWithColor];
};

export const updateFormattingRules = (
  previousFormattingRules: FormattingRule[],
  updatedFormattingRuleId: string,
  updatedFormattingRulePayload: Partial<FormattingRule>
) => {
  const updatedFormattingRuleIndex = previousFormattingRules.findIndex(
    formattingRule => formattingRule.__id === updatedFormattingRuleId
  );
  const previousValues = previousFormattingRules[updatedFormattingRuleIndex];

  return Object.assign([], previousFormattingRules, {
    [updatedFormattingRuleIndex]: {
      ...previousValues,
      ...updatedFormattingRulePayload,
    },
  });
};

export const deleteFormattingRule = (
  previousFormattingRules: FormattingRule[],
  deletedFormattingRuleId: string
) =>
  previousFormattingRules.filter(
    formattingRule => formattingRule.__id !== deletedFormattingRuleId
  );

export const reorderFormattingRules = (
  previousFormattingRules: FormattingRule[],
  reorderedFormattingRulesIds: string[]
) => {
  const formattingRulesIndexedById = Object.fromEntries(
    previousFormattingRules.map(rule => [rule.__id, rule])
  );

  return reorderedFormattingRulesIds.map(id => formattingRulesIndexedById[id]);
};
